module.exports = {
  2500: { human: 'bis 2.500 km', api: 2500 },
  7500: { human: 'bis 7.500 km', api: 7500 },
  10000: { human: 'bis 10.000 km', api: 10000 },
  15000: { human: 'bis 15.000 km', api: 15000 },
  15001: { human: 'mehr als 15.000 km', api: 15001 }
}
